<template>
  <div
    data-test="root"
    class="rounded-8 bg-bg-base-bg4 w-fit text-label-r-13-18 text-fg-base-fg10 px-2 py-1 my-[6px]"
    :class="{
      'cursor-pointer': isClickable,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ isClickable?: boolean, withPhoto?: boolean }>(), {
  isClickable: false,
})
</script>
